import {
  BookOpen,
  Bot,
  CircleAlert,
  Database,
  FileText,
  List,
  LoaderCircle,
  Pencil,
  Search,
  Table,
  Wrench,
} from "lucide-react";
import { useState } from "react";
import { TOOL_PRESENTATION, type ToolIconName } from "./tool-call-presentation";
const icons = {
  document: FileText,
  edit: Pencil,
  search: Search,
  database: Database,
  book: BookOpen,
  list: List,
  table: Table,
  bot: Bot,
  wrench: Wrench,
} satisfies Record<ToolIconName, typeof Wrench>;

export const ToolCallIcon = ({
  name,
  integrationIcon,
  active = false,
  failed = false,
  size = 16,
}: {
  name: string;
  integrationIcon: string | null;
  active?: boolean;
  failed?: boolean;
  size?: 14 | 16;
}) => {
  const [failedIcon, setFailedIcon] = useState<string | null>(null);
  const Icon = failed
    ? CircleAlert
    : active
      ? LoaderCircle
      : icons[TOOL_PRESENTATION[name]?.icon ?? "wrench"];
  const className = `pointer-events-none relative shrink-0 ${size === 14 ? "h-[14px] w-[14px]" : "h-[16px] w-[16px]"}`;
  return integrationIcon &&
    failedIcon !== integrationIcon &&
    !failed &&
    !active ? (
    <img
      src={integrationIcon}
      alt=""
      className={`${className} object-contain`}
      onError={() => setFailedIcon(integrationIcon)}
    />
  ) : (
    <Icon
      aria-hidden="true"
      className={`${className} ${failed ? "text-[#b91c1c]" : active ? "animate-spin text-[#074ee8]" : ""}`}
    />
  );
};
